import Vue from 'vue';
import Router from 'vue-router';

import home from './views/home.vue';
import homeNoHeader from './views/homeNoHeader.vue';
import main from './views/main.vue';
import demo from './views/demo.vue';
import activities from './views/activities.vue';
import doctor from './views/doctor.vue';
import doctorGroup from './views/doctorGroup.vue';
import encyclopedia from './views/encyclopedia.vue';
import introduction from './views/introduction.vue';
import textview from './views/textview.vue';
import treatment from './views/treatment.vue';
import treatmentDetail from './views/treatmentDetail.vue';
import officeCenter from './views/OfficeCenter.vue';
import registSubscribe from './views/RegistSubscribe.vue';
import bindPatient from './views/bindPatient.vue';
import chargeDetail from './views/chargeDetail.vue';
import subscribeInfo from './views/subscribeInfo.vue';
import caseSearch from './views/caseSearch.vue';
import userCenter from './views/userCenter.vue';
import tiketList from './views/tiketList.vue';
import tiketGet from './views/tiketGet.vue';
import myTicket from './views/MyTicket.vue';
import ticketCheck from './views/ticketCheck.vue';
import linkPage from './views/linkpage.vue';

Vue.use(Router);

export default new Router({
  routes: [{
    path: '/',
    name: 'main',
    component: main,
  }, {
    path: '/',
    name: 'home',
    component: home,
    children: [{
      path: '/demo',
      name: 'demo',
      component: demo,
    }, {
      path: '/activities',
      name: '诊所活动',
      component: activities,
    }, {
      path: '/doctor',
      name: '医师详情',
      component: doctor,
    }, {
      path: '/doctorGroup',
      name: '医师团队',
      component: doctorGroup,
    }, {
      path: '/encyclopedia',
      name: '口腔百科',
      component: encyclopedia,
    }, {
      path: '/introduction',
      name: '诊所介绍',
      component: introduction,
    }, {
      path: '/textview',
      name: '详情',
      component: textview,
    }, {
      path: '/treatment',
      name: '诊疗项目',
      component: treatment,
    }, {
      path: '/treatmentDetail',
      name: '诊疗项目',
      component: treatmentDetail,
    }, {
      path: '/officeCenter',
      name: '我要咨询',
      component: officeCenter,
    }],
  }, {
    path: '/',
    name: 'home',
    component: homeNoHeader,
    children: [, {
      path: '/registSubscribe',
      name: '预约挂号',
      component: registSubscribe,
    }, {
      path: '/linkPage',
      name: '',
      component: linkPage,
    }, {
      path: '/bindPatient',
      name: '绑定就诊号',
      component: bindPatient,
    }, {
      path: '/chargeDetail',
      name: '收费查询',
      component: chargeDetail,
    }, {
      path: '/subscribeInfo',
      name: '预约信息',
      component: subscribeInfo,
    }, {
      path: '/caseSearch',
      name: '病例信息',
      component: caseSearch,
    }, {
      path: '/userCenter',
      name: '个人中心',
      component: userCenter,
    }, {
      path: '/tiketList',
      name: '我的优惠券',
      component: tiketList,
    }, {
      path: '/tiketGet',
      name: '优惠券领取',
      component: tiketGet,
    }, {
      path: '/myTicket',
      name: '我的优惠券',
      component: myTicket,
    }],
  }, {
    path: '/ticketCheck',
    name: 'ticketCheck',
    component: ticketCheck,
  }],
});
